console.log('KOVA DELIVERY LOADED');

document.addEventListener('DOMContentLoaded', function () {
  var PICKUP_LOCATION = 'KOVA Burlington';
  var PICKUP_ADDRESS = '945 Syscon Rd, Burlington, Ontario L7L 5S3, Canada';

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function refreshPdpDeliveryCards() {
    document.querySelectorAll('.kova-delivery-card').forEach(function (card) {
      var input = card.querySelector('input[name="properties[Delivery Method]"]');
      if (!input) return;

      card.classList.toggle('selected', input.checked);
    });
  }

  function getSelectedCartDelivery() {
    return document.querySelector('input[name="kova_cart_delivery"]:checked');
  }

  function refreshCartDeliveryCards() {
    document.querySelectorAll('.kova-cart-card').forEach(function (card) {
      var input = card.querySelector('input[name="kova_cart_delivery"]');
      if (!input) return;

      card.classList.toggle('selected', input.checked);
    });
  }

  function updateCartDelivery() {
    var selectedCartDelivery = getSelectedCartDelivery();
    var pickupInfo = document.querySelector('#kova_pickup_info');

    if (!selectedCartDelivery) return Promise.resolve();

    refreshCartDeliveryCards();

    if (selectedCartDelivery.value === 'Pickup') {
      if (pickupInfo) pickupInfo.style.display = 'block';

      return updateCartAttributes({
        'Delivery Method': 'Pickup',
        'Pickup Location': PICKUP_LOCATION,
        'Pickup Address': PICKUP_ADDRESS
      });
    }

    if (pickupInfo) pickupInfo.style.display = 'none';

    return updateCartAttributes({
      'Delivery Method': 'Shipping',
      'Pickup Location': '',
      'Pickup Address': ''
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (target.matches('input[name="properties[Delivery Method]"]')) {
      refreshPdpDeliveryCards();
    }

    if (target.matches('input[name="kova_cart_delivery"]')) {
      updateCartDelivery();
    }
  });

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
    );

    if (!checkoutButton) return;

    var selectedCartDelivery = getSelectedCartDelivery();

    if (!selectedCartDelivery) return;

    event.preventDefault();
    event.stopPropagation();

    updateCartDelivery().then(function () {
      if (selectedCartDelivery.value === 'Pickup') {
        window.location.href = '/checkout?delivery_method=pickup';
      } else {
        window.location.href = '/checkout?delivery_method=shipping';
      }
    });
  });

  refreshPdpDeliveryCards();
  refreshCartDeliveryCards();
  updateCartDelivery();
});